import { selectCurrentMenuTypes, selectCategories, selectSubcategories, selectChangeMassUpdateDataSelectionCriteria } from './chunk-RO5AAHK3.mjs';
import { i18n_config_default } from './chunk-5FPUWZMY.mjs';
import { useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

var ItemMassUpdateCategoryOrSubcategoryOptions = /* @__PURE__ */ ((ItemMassUpdateCategoryOrSubcategoryOptions2) => {
  ItemMassUpdateCategoryOrSubcategoryOptions2[ItemMassUpdateCategoryOrSubcategoryOptions2["ALL"] = 0] = "ALL";
  ItemMassUpdateCategoryOrSubcategoryOptions2[ItemMassUpdateCategoryOrSubcategoryOptions2["CATEGORY"] = 1] = "CATEGORY";
  ItemMassUpdateCategoryOrSubcategoryOptions2[ItemMassUpdateCategoryOrSubcategoryOptions2["SUBCATEGORY"] = 2] = "SUBCATEGORY";
  return ItemMassUpdateCategoryOrSubcategoryOptions2;
})(ItemMassUpdateCategoryOrSubcategoryOptions || {});
var useItemMassUpdate = (isActive) => {
  const [selectedMenuTypes, setSelectedMenuTypes] = useState([]);
  const [selectedCategoryIds, setSelectedCategoryIds] = useState(null);
  const [selectedSubcategoryIds, setSelectedSubcategoryIds] = useState(null);
  const [selectedCategoryOrSubcategory, setSelectedCategoryOrSubcategory] = useState(0 /* ALL */);
  const currentMenuTypes = useSelector(selectCurrentMenuTypes);
  const currentCategories = useSelector(selectCategories);
  const currentSubcategories = useSelector(selectSubcategories);
  const selectionCriteria = useSelector(
    selectChangeMassUpdateDataSelectionCriteria
  );
  useEffect(() => {
    if (isActive !== true || !selectionCriteria) {
      setSelectedMenuTypes([]);
      setSelectedCategoryOrSubcategory(
        0 /* ALL */
      );
      setSelectedCategoryIds(null);
      setSelectedSubcategoryIds(null);
      return;
    }
    setSelectedMenuTypes(
      selectionCriteria.menuTypeIds.map((id) => ({
        label: currentMenuTypes[id].name,
        value: id
      }))
    );
    if (selectionCriteria.categoryIds !== null) {
      setSelectedCategoryOrSubcategory(
        1 /* CATEGORY */
      );
    } else if (selectionCriteria.subcategoryIds !== null) {
      setSelectedCategoryOrSubcategory(
        2 /* SUBCATEGORY */
      );
    } else
      setSelectedCategoryOrSubcategory(
        0 /* ALL */
      );
    setSelectedCategoryIds(selectionCriteria.categoryIds);
    setSelectedSubcategoryIds(selectionCriteria.subcategoryIds);
  }, [isActive, currentMenuTypes, selectionCriteria]);
  const optionsFactory = useCallback(
    (bucket) => {
      let selectedBucket = {};
      const allowedIds = /* @__PURE__ */ new Set();
      switch (bucket) {
        case "menuTypes":
          selectedBucket = currentMenuTypes;
          break;
        case "categories":
          selectedBucket = currentCategories;
          if (selectedMenuTypes.length > 0) {
            selectedMenuTypes.forEach(({ value }) => {
              currentMenuTypes[value].categoryIds.forEach(
                (id) => allowedIds.add(id)
              );
            });
          }
          break;
        case "subcategories":
          selectedBucket = currentSubcategories;
          if (selectedMenuTypes.length > 0) {
            selectedMenuTypes.forEach(({ value }) => {
              currentMenuTypes[value].categoryIds.forEach(
                (id) => currentCategories[id].subcategoryIds.forEach(
                  (subcategoryId) => allowedIds.add(subcategoryId)
                )
              );
            });
          }
          break;
      }
      const options = Object.keys(selectedBucket).map((key) => {
        return {
          value: Number(key),
          label: selectedBucket[Number(key)].name
        };
      }).filter(({ value }) => {
        if (allowedIds.size === 0)
          return true;
        return allowedIds.has(value);
      });
      const dropdownOptions = [
        [
          {
            value: 0 /* ALL */,
            label: i18n_config_default.t("commonTexts.all")
          }
        ],
        options
      ];
      return dropdownOptions;
    },
    [
      selectedMenuTypes,
      currentMenuTypes,
      currentSubcategories,
      currentCategories,
      i18n_config_default.t
    ]
  );
  const totalItems = useMemo(() => {
    const items = /* @__PURE__ */ new Set();
    selectedMenuTypes.forEach(({ value }) => {
      const menuType = currentMenuTypes[value];
      const menuTypeItems = new Set(currentMenuTypes[value].itemIds);
      if (selectedCategoryOrSubcategory === 0 /* ALL */) {
        menuType.itemIds.forEach((item) => items.add(item));
        return items;
      }
      if (selectedCategoryIds) {
        selectedCategoryIds.forEach((categoryId) => {
          const currentCategory = currentCategories[categoryId];
          if (!currentCategory)
            return;
          currentCategory.itemIds.forEach((itemId) => {
            if (menuTypeItems.has(itemId))
              items.add(itemId);
          });
        });
      }
      if (selectedSubcategoryIds) {
        selectedSubcategoryIds.forEach((subcategoryId) => {
          const currentSubcategory = currentSubcategories[subcategoryId];
          if (!currentSubcategory)
            return;
          currentSubcategories[subcategoryId].itemIds.forEach((itemId) => {
            if (menuTypeItems.has(itemId))
              items.add(itemId);
          });
        });
      }
    });
    return items;
  }, [
    selectedMenuTypes,
    selectedCategoryIds,
    selectedSubcategoryIds,
    currentMenuTypes,
    currentCategories,
    currentSubcategories,
    selectedCategoryOrSubcategory
  ]);
  const handleSelectedMenuTypes = (values) => {
    if (values.length === 0) {
      setSelectedCategoryIds(null);
      setSelectedSubcategoryIds(null);
      setSelectedMenuTypes(values);
      return;
    }
    for (const { value } of values) {
      if (value === 0) {
        setSelectedMenuTypes(optionsFactory("menuTypes")[1]);
        return;
      }
    }
    setSelectedMenuTypes(values);
  };
  const handleSelectCategoryOrSubcategory = (option) => {
    setSelectedSubcategoryIds(null);
    setSelectedCategoryIds(null);
    setSelectedCategoryOrSubcategory(option);
  };
  const handleCategoryOrSubcategory = (ids) => {
    if (selectedCategoryOrSubcategory === 1 /* CATEGORY */) {
      setSelectedSubcategoryIds(null);
      setSelectedCategoryIds(ids);
    } else if (selectedCategoryOrSubcategory === 2 /* SUBCATEGORY */) {
      setSelectedCategoryIds(null);
      setSelectedSubcategoryIds(ids);
    }
  };
  return {
    totalItems,
    handleSelectedMenuTypes,
    handleSelectCategoryOrSubcategory,
    handleCategoryOrSubcategory,
    selectedMenuTypes,
    selectedCategoryIds,
    selectedSubcategoryIds,
    selectedCategoryOrSubcategory,
    optionsFactory
  };
};

export { ItemMassUpdateCategoryOrSubcategoryOptions, useItemMassUpdate };
